import { render, staticRenderFns } from "./ResidenceCounter.vue?vue&type=template&id=68a34d46&"
import script from "./ResidenceCounter.vue?vue&type=script&lang=js&"
export * from "./ResidenceCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/ensign-boligprosjekter/app/public/wp-content/plugins/ensign-boligprosjekter/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68a34d46')) {
      api.createRecord('68a34d46', component.options)
    } else {
      api.reload('68a34d46', component.options)
    }
    module.hot.accept("./ResidenceCounter.vue?vue&type=template&id=68a34d46&", function () {
      api.rerender('68a34d46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResidenceCounter.vue"
export default component.exports